<template>
	<div id="teamModalComponent">
		<button class="btn-link" data-toggle="modal" data-target=".team-modal" ref="btnShowTeamModalComponent" v-show="false" @click="setTeamModal">Nueva Campaña</button>

		<div class="modal fade team-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" v-if="idLocal == 0">Nueva Campaña</h5>
						<h5 class="modal-title" v-else>Campaña {{ title }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModalLocal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label for="inputName">Nombre</label>
									<input type="text" class="form-control form-control-sm" v-model='objectTeam.name' placeholder="Nombre">
								</div>
							</div>
							<div class="col-md-8">
								<div class="form-group">
									<label for="inputName">Descripcion</label>
									<input type="text" class="form-control form-control-sm" v-model='objectTeam.description' placeholder="Descripción">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-5">
								<div class="form-group">
									<label for="inputClient">Cliente</label>
									<autocomplete-input-component
										_class="form-control form-control-sm"
										:_path="apiBackend + 'clients/getByUser'"
										@actionSelectItem="setClientLocal"
										ref="autoCompleteClient"></autocomplete-input-component>
								</div>
							</div>
							<div class="form-group col-md-5">
								<label for="inputTypeClient">Campo Administrativo</label>
								<select id="inputTypeClient" class="form-control form-control-sm" v-model="objectTeam.entity_id">
									<option v-for="(item, index) in listEntities" :key="index" :value="item.id">{{ item.name }}</option>
								</select>
							</div>

						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label for="inputName">Fecha de Inicio</label>
									<input type="date" class="form-control form-control-sm" v-model='objectTeam.begin_date' placeholder="">
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label for="inputName">Fecha de cierre</label>
									<input type="date" class="form-control form-control-sm" v-model='objectTeam.end_date'>
								</div>
							</div>
						</div>

					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-sm btn-primary" @click="saveTeamLocal">Guardar</button>
						<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" @click="closeModalLocal" ref="bntCloseModalLocal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import team from '@/mixins/teams'
	import entity from '@/mixins/generals/entity'

	import AutoCompleteInputComponent from '@/components/AutoCompleteInputComponent.vue'

	export default {
		name: 'TeamModalComponent',
		mixins: [axiosAction, errors, mixin, team, entity],
		props: ['id'],
		data () {
			return {
				title: ''
			}
		},
		computed: {
			idLocal() {
				if(this.id == 0) {
					this.clearObjectTeamLocal()
				} else {
					this.showTeamLocal()
				}
				return this.id
			}
		},
		methods: {
			clearObjectTeamLocal() {
				this.clearObjectTeam()
			},
			closeModalLocal() {
				this.clearObjectTeamLocal()
				this.$refs.autoCompleteClient.$refs.clear.click()
			},
			getAllEntitiesResultLocal(response) {},
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'getAllEntitiesResult': this.getAllEntitiesResult(response); break;
					case 'saveTeamResult': this.saveTeamResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			saveTeamLocal() {
				this.saveTeam()
			},
			saveTeamResultLocal(response) {
				if(response.data.success === true) {
					this.$emit('saveTeam', response.data)
					this.$refs.bntCloseModalLocal.click()
				}
			},
			setClientLocal(item){
				this.objectTeam.client_id = item.id
			},
			setTeamModal() {
				if(this.listEntities.length == 0) {
					this.getAllEntities()
				}
			},
			showTeamLocal() {
				this.title = this.id
				this.showTeam(this.id)
			},
			showTeamResultLocal(response) { console.log(response) }
		},
		components: {
			'autocomplete-input-component': AutoCompleteInputComponent,
		},

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
